export default "__VITE_ASSET__hkQRamuJ__"